import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"

const Post = ({
  post,
  category = false,
  heading = 2,
  date = false,
  excerpt = false,
}) => {
  return (
    <article>
      <Link to={`/${post.parent.name}/`} className="p-postLink">
        <div className="p-postThumb">
          <figure>
            {post.frontmatter.image?.childImageSharp?.gatsbyImageData ? (
              <GatsbyImage
                image={getImage(post.frontmatter.image)}
                alt={post.frontmatter.title}
                className="p-postImg"
              />
            ) : (
              <StaticImage
                src="../images/site-header.jpg"
                alt="No Image"
                className="p-postImg"
                objectFit="cover"
              />
            )}
          </figure>
          {category && (
            <span
              className="c-catLabel"
              style={{ background: `${post.frontmatter.categories[0].color}` }}
            >
              {post.frontmatter.categories[0].title}
            </span>
          )}
        </div>
        <div className="p-postBody">
          {heading === 2 && (
            <h2 className="p-postHeading">{post.frontmatter.title}</h2>
          )}
          {heading === 3 && (
            <h3 className="p-postHeading">{post.frontmatter.title}</h3>
          )}
          {heading === 4 && (
            <h4 className="p-postHeading">{post.frontmatter.title}</h4>
          )}
          {excerpt && <p className="p-postExcerpt">{post.excerpt}</p>}
          {date && (
            <ul className="c-postDateList">
              {post.frontmatter?.lastmod <= post.frontmatter.date ? (
                <li className="c-postDateItem">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="14px"
                    viewBox="0 0 24 24"
                    width="14px"
                    fill="currentColor"
                  >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                  </svg>
                  <time dateTime={post.frontmatter.date}>
                    {post.frontmatter.dateJP}
                  </time>
                </li>
              ) : (
                <li className="c-postDateItem">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enableBackground="new 0 0 24 24"
                    height="14px"
                    viewBox="0 0 24 24"
                    width="14px"
                    fill="currentColor"
                  >
                    <g>
                      <rect fill="none" height="24" width="24" />
                    </g>
                    <g>
                      <g>
                        <path d="M11,8v5l4.25,2.52l0.77-1.28l-3.52-2.09V8H11z M21,10V3l-2.64,2.64C16.74,4.01,14.49,3,12,3c-4.97,0-9,4.03-9,9 s4.03,9,9,9s9-4.03,9-9h-2c0,3.86-3.14,7-7,7s-7-3.14-7-7s3.14-7,7-7c1.93,0,3.68,0.79,4.95,2.05L14,10H21z" />
                      </g>
                    </g>
                  </svg>
                  <time dateTime={post.frontmatter.lastmod}>
                    {post.frontmatter.lastmodJP}
                  </time>
                </li>
              )}
            </ul>
          )}
        </div>
      </Link>
    </article>
  )
}

export default Post
